/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import './App.css';
import { Switch, Route } from 'react-router-dom';
// eslint-disable-next-line import/named
import {
  HOME,
  EXPLORE,
  LOGIN,
  CHATS,
  STORE,
  PROFILE,
  REGISTER,
  RESET_PASSWORD,
  OTP_CODE,
  SET_PASSWORD,
  SUCCESS,
} from './routes';

import Home from './pages/Home';
import Explore from './pages/Explore';
import AuthLayout from './pages/AuthLayout';
import Login from './pages/Login';
import Register from './pages/Register';
import ResetPassword from './pages/ResetPassword';
import OtpCode from './pages/OtpCode';
import SetNewPassword from './pages/SetNewPassword';
import PageNotFound from './pages/PageNotFound';
import SuccessOnboarding from './pages/SuccessOnboarding';
import Chats from './pages/Chats';
import Store from './pages/Store';
import Profile from './pages/Profile';

function App() {
  return (
    <>
      <Switch>
        <Route path="/" exact component={AuthLayout} />
        <Route path={HOME} exact component={Home} />
        <Route path={EXPLORE} exact component={Explore} />
        <Route path={LOGIN} exact component={Login} />
        <Route path={REGISTER} exact component={Register} />
        <Route path={RESET_PASSWORD} exact component={ResetPassword} />
        <Route path={OTP_CODE} exact component={OtpCode} />
        <Route path={SET_PASSWORD} exact component={SetNewPassword} />
        <Route path={SUCCESS} exact component={SuccessOnboarding} />
        <Route path={CHATS} exact component={Chats} />
        <Route path={STORE} exact component={Store} />
        <Route path={PROFILE} exact component={Profile} />
        <Route component={PageNotFound} />
      </Switch>
    </>
  );
}

export default App;
